import { createContext, PropsWithChildren, useContext, useEffect, useState } from 'react';

import { Loader } from '@/components/core/Loader';
import { getInjector } from '@/services/angularjs-bridge';
import { Organization } from '@/types/Organization';

interface OrganizationContextInterface {
    organization?: Organization;
}

const OrganizationContext = createContext<OrganizationContextInterface | undefined>(undefined);

const useOrganization = () => {
    const organizationContext = useContext(OrganizationContext);

    if (!organizationContext) {
        throw new Error('useOrganization must be used within an OrganizationProvider');
    }

    return organizationContext;
};

const OrganizationProvider = ({ children }: PropsWithChildren) => {

    const [organization, setOrganization] = useState<Organization | undefined>(undefined);

    useEffect(() => {
        // Grab $rootScope from the angularjs world
        const angularJSInjector = getInjector();
        const $rootScope = angularJSInjector.get('$rootScope');
        setOrganization($rootScope.organization);
    }, []);

    if (!organization) {
        return <Loader />;
    } else {
        return <OrganizationContext.Provider value={{ organization }}>{children}</OrganizationContext.Provider>;
    }

};

export { OrganizationContext, OrganizationProvider, useOrganization };
